<template src="./index.html"></template>
<script>
import { getdata } from './data.js';
import {
	indexExpage,
	templatepage,
	noticeindexpage,
	userpage,
	userGroupsave,
	grouppage,
	saveIndex,
	indexExgetOne,
	groupdelete,
	indexdelete,
	noticetemplate,
	fetchGroupUser,
	fxjk_comapny
} from '../../../../api/Notificationsettings.js';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';
export default {
	name: 'tzsz',
	components: {
		quillEditor
	},
	data: function() {
		return {
			content: '',
			sfqy: '',
			titlemb: '',
			mbData: [
				// {
				// 	label: "短信",
				// },
				{
					label: '邮箱'
				}
				// {
				// 	label: "钉钉机器人",
				// },
			],
			name: '',
			radios: null,
			dialogVisible: false,
			shaidiag: true,
			tableData: getdata().tableData,
			headData: getdata().headData,
			sjlydiag: false,
			ywdiag: false,
			pagination: getdata().pagination,
			searchlist: getdata().searchlist,
			searchdiag: false,
			searchdata: getdata().searchdata,
			paginationtzz: getdata().paginationtzz,
			ruleForm: {
				test1: '',
				test2: '',
				test3: '',
				test4: '',
				test5: ''
			},
			options: getdata().options,
			value: '',
			mValue: '',
			elSelect: '',
			glData: [{}, {}],
			tableDataleft: [],
			headDataleft: getdata().headDataleft,
			tableDataright: [],
			headDataright: getdata().headDataright,
			radio: '1',
			rabios: null,
			glzb_nsrmc: '',
			tzdiag: false,
			headDatatz: getdata().headDatatz,
			tableDatatz: [],
			Createtzdiag: false,
			headDataCreate: getdata().headDataCreate,
			tableDataCreate: [],
			headDatazb: getdata().headDatazb,
			tableDatazb: [],
			zbdiag: false,
			tablekey: 0,
			title: '',
			chooseindex: 0,
			overlength: 0,
			disableds: false,
			groupIdList: [],
			lrdetail: false,
			editorOption: {
				modules: {
					toolbar: [
						['bold', 'italic', 'underline', 'strike', 'link', 'image', 'code-block'], // toggled buttons
						[
							{
								align: []
							}
						], //对齐方式
						[
							{
								header: [1, 2, 3, 4, 5, 6, false]
							}
						], //几级标题
						[
							{
								font: []
							}
						], //字体
						[
							{
								size: ['small', 'normal', 'large', 'huge']
							}
						],
						[
							{
								color: []
							},
							{
								background: []
							}
						] // 字体颜色，字体背景颜色
					]
				}
			},
			listset: {
				one: [],
				out: [],
				three: []
			},
			suosq: this.$getdefultMonth(),
			ouglist: [],
			search: '',
			inputlist: {
				cjzm: '',
				tzss: '',
				mbname: {},
				mbss: '',
				input: '',
				tzdx: '',
				tzpl: '1天/次',
				time: '',
				tzmc: '',
				groupId: '',
				id: null,
				isshow: false
			},
			idsss: false
		};
	},
	created() {},
	mounted() {
		this.updatalist();
		this.mbpages();
		fxjk_comapny().then(res => {
			if (res.data.code == 1) {
				this.elSelect = res.data.data.map(item => {
					return {
						value: item.companyCode,
						label: item.nsrmc
					};
				});
			}
		});
	},
	methods: {
		select_out(e) {
			let list = this.$refs.zbtable.getSelectionval();
			list.map((item1, index1) => {
				let num = 0;
				if (this.ouglist.length != 0) {
					this.ouglist.map((item, index) => {
						if (item.id == item1.id) {
							num = 1;
						} else if (item.id != item1.id && num == 0 && index == this.ouglist.length - 1) {
							this.ouglist.push(item1);
						}
					});
				} else {
					this.ouglist.push(item1);
				}
			});
			let lists = [];
			this.tableDatazb.map((item1,index1) => {
				let num = 0;
				if(list.length!=0){
					list.map((item, index) => {
						if (item.id == item1.id) {
							num = 1;
						} else if (num == 0 && index == list.length - 1 && item.id != item1.id) {
							lists.push(item1.id)
						}
					});
				}else{
					this.ouglist.map((item,index)=>{
						if(item.id==item1.id){
							this.ouglist.splice(index,1)
						}
					})
				}
			});
			for(let a = 0 ; a < lists.length ; a ++){
				this.ouglist.map((item,index)=>{
					if(lists[a]==item.id){
						this.ouglist.splice(index,1)
					}
				})
			}
			if(!e){
				this.zdzb();
			}
		},
		geOoverLength(e) {
			this.overlength = e;
		},
		CreatReturn() {
			(this.Createtzdiag = false), (this.inputlist.groupId = '');
		},
		tzdiags(e) {
			this.Createtzdiag = true;
			this.inputlist.groupId = e.id;
			this.edit();
			this.inputlist.cjzm = e.groupName;
		},
		pinlv() {
			this.value = '';
			this.mValue = '';
		},
		timezhou(e) {
			if (e) {
				let time = new Date(e);
				let zhou = time.getDay();
				if (zhou == 0) {
					zhou = 7;
				}
				this.value = `${zhou}`;
			} else {
				let time = new Date();
				let zhou = time.getDay();
				if (zhou == 0) {
					zhou = 7;
				}
				let val;
				if (zhou > this.value) {
					let num = zhou - this.value;
					val = time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + (time.getDate() - num);
				} else {
					let num = this.value - zhou;
					val = time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + (time.getDate() + num);
				}
				this.value = val + ':' + this.mValue;
			}
		},
		forseejcxinxi() {},
		nextmbxz() {
			let enable = this.sfqy ? 0 : 1;
			let params = {
				noticeType: 2,
				noticeTemplateName: this.name,
				noticeTemplateContent: this.content,
				enable
			};
			if (this.chooseindex + 1 == 2) {
				params.noticeTemplateTitle = this.title;
			}
			if (this.id == null) {
				params.id = this.id;
			}
			noticetemplate(params).then(res => {
				if (res.data.code == 1) {
					this.lrdetail = false;
					this.mbpage();
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		xztzmb() {
			this.lrdetail = true;
			this.chooseindex = 0;
			this.content = '';
			this.sfqy = false;
			this.title = '';
			this.name = '';
			this.disableds = false;
		},
		tzmbck(e) {
			this.disableds = true;
			this.lrdetail = true;
			this.chooseindex = 0;
			this.name = e.noticeTemplateName;
			this.title = e.noticeTemplateTitle;
			this.sfqy = e.enable == 0 ? true : false;
			this.content = e.noticeTemplateContent;
		},
		deluplist() {
			let ids = this.$refs.tableboxs.getSelectionval();
			if (ids.length == 0) {
				return this.$message.error('请选择你要删除的数据');
			}
			this.$showConfirm({
				message: '确认删除?'
			}).then(res => {
				if (res == 'confirm') {
					let id = [];
					ids.map(item => {
						id.push(item.id);
					});
					indexdelete(id).then(res => {
						if (res.data.code == 1) {
							this.$message.success('删除成功');
							this.updatalist();
						} else {
							this.$message.error(res.data.code);
						}
					});
				}
			});
		},
		deletes(e) {
			this.$showConfirm({
				message: '确认删除?'
			}).then(res => {
				if (res == 'confirm') {
					let params = {
						id: e.id
					};
					groupdelete(params).then(res => {
						if (res.data.code == 1) {
							this.$message.success('删除成功');
							this.group();
						} else {
							this.$message.error(res.data.code);
						}
					});
				}
			});
		},
		left() {
			let listup = this.$refs.tableright.getSelectionval();
			listup.map(item => {
				for (let a = 0; a < this.tableDataright.length; a++) {
					if (item.id == this.tableDataright[a].id) {
						this.tableDataright.splice(a, 1);
					}
				}
				this.tableDataleft.push(item);
			});
		},
		right() {
			let listup = this.$refs.tableleft.getSelectionval();
			listup.map(item => {
				for (let a = 0; a < this.tableDataleft.length; a++) {
					if (item.id == this.tableDataleft[a].id) {
						this.tableDataleft.splice(a, 1);
					}
				}
				this.tableDataright.push(item);
			});
			this.zbdiag = false;
		},
		delsget(e, i) {
			let params = {
				id: e.id
			};
			this.inputlist.input = '';
			this.search = '';
			if (i == 1) {
				this.inputlist.isshow = true;
			} else {
				this.inputlist.isshow = false;
				this.group();
			}
			indexExgetOne(params).then(res => {
				if (res.data.code == 1) {
					let datas = res.data.data;
					this.tableDataright = datas.userGroups;
					this.inputlist.id = datas.id;
					this.inputlist.tzmc = datas.noticeMc;
					this.inputlist.mbname = {
						noticeTemplateName: datas.noticeTemplateName,
						id: datas.noticeTemplateId
					};
					this.radio = datas.relationRisk;
					this.inputlist.time = datas.noticeStopTime;
					if (datas.noticePingl == '1周/次') {
						let itemList = datas.noticeTime.split(':');
						this.value = itemList[0];
						this.timezhou(this.value);
						this.mValue = itemList[1] + ':' + itemList[2];
					} else {
						this.value = datas.noticeTime;
					}
					this.inputlist.tzpl = datas.noticePingl;
					this.glData = datas.risks;
					this.ouglist = datas.risks;
					let params = {
						size: 1000000000,
						current: this.paginationtzz.pageNum,
						groupName: this.search
					};
					grouppage(params).then(res => {
						if (res.data.code == 1) {
							this.dialogVisible = true;
							this.tableDataleft = res.data.data.records;
							this.tableDataright.map(item => {
								for (let a = 0; a < this.tableDataleft.length; a++) {
									if (item.id == this.tableDataleft[a].id) {
										this.tableDataleft.splice(a, 1);
										break;
									}
								}
							});
						} else {
							this.$message.error(res.data.msg);
						}
					});
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},

		deletezb(index) {
			this.glData.splice(index, 1);
		},
		tzdig() {
			this.paginationtzz.pageNum = '1';
			this.mbpage();
		},
		rabio(e) {
			this.rabios = e;
		},
		mbpage() {
			if (this.inputlist.mbname.id) {
				this.radios = this.inputlist.mbname.id;
			}
			let params = {
				size: this.paginationtzz.pageSize,
				current: this.paginationtzz.pageNum,
				noticeTemplateName: this.search
			};
			templatepage(params).then(res => {
				if (res.data.code == 1) {
					this.paginationtzz.total = parseFloat(res.data.data.total);
					this.tableDatatz = res.data.data.records;
					this.tzdiag = true;
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		mbpages() {
			let params = {
				size: '10000000000',
				current: '1',
				...this.search
			};
			templatepage(params).then(res => {
				if (res.data.code == 1) {
					this.searchlist[1].selectval = [];
					res.data.data.records.map(item => {
						this.searchlist[1].selectval.push({
							label: item.noticeTemplateName,
							value: item.id
						});
					});
					this.idsss = true;
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		nextxz() {
			if (this.inputlist.tzmc == '') {
				return this.$message.error('名称不能为空');
			}
			if (this.inputlist.tzpl == '1周/次') {
				this.timezhou();
			}
			if (this.value == null || this.value == '') {
				return this.$message.error('请输入通知时间');
			} else if (this.inputlist.tzpl == '1周/次') {
				if (!this.mValue || this.mValue == null || this.mValue == '') {
					return this.$message.error('请输入通知时刻');
				}
			}
			if (this.inputlist.time == null || this.inputlist.time == '') {
				return this.$message.error('请输入通知停止时间');
			}
			this.title = '编辑通知';
			let noticeGroupList = [];
			let { time, tzpl, mbname, tzmc, id } = this.inputlist;
			let riskList = [];
			this.glData.map(item => {
				riskList.push(item.id);
			});
			this.tableDataright.map(item => {
				noticeGroupList.push(item.id);
			});
			let params = {
				noticeGroupList,
				noticeMc: tzmc,
				noticePingl: tzpl,
				noticeStopTime: time,
				noticeTemplateId: mbname.id || '',
				noticeTime: this.value,
				riskList,
				relationRisk: this.radio
			};
			if (id != null && id != '') {
				params.id = id;
			}
			saveIndex(params).then(res => {
				if (res.data.code == 1) {
					this.dialogVisible = false;
					if (params.id) {
						this.$message.success('编辑成功');
					} else {
						this.$message.success('新建成功');
					}
					this.updatalist();
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		nextzb() {
			this.select_out(1)
			this.glData = this.ouglist;
			for (let i = 0; i < this.glData.length; i++) {
				for (let a = i + 1; a < this.glData.length; a++) {
					if (this.glData[i].id == this.glData[a].id) {
						this.glData.splice(i, 1);
						a--;
					}
				}
			}
			this.zbdiag = false;
		},
		nextmb() {
			if (this.rabios == null) {
				this.rabios = {
					noticeTemplateName: ''
				};
			}
			this.inputlist.mbname = this.rabios;
			this.tzdiag = false;
		},
		nexttz() {
			let list = this.$refs.grouplist.getSelectionval();
			let deleteList = [];
			this.tableDataCreate.map(item => {
				let num = 0;
				if (list.length == 0) {
					deleteList.push(item);
				} else {
					list.map((item1, index) => {
						if (item.id == item1.id) {
							num++;
						} else if (item.id != item1.id && index == list.length - 1 && num == 0) {
							deleteList.push(item);
						}
					});
				}
			});
			list.map(item => {
				this.groupIdList.push(Number(item.id));
			});
			let a = Array.from(new Set(this.groupIdList));
			this.groupIdList = a;
			deleteList.map(item => {
				this.groupIdList.map((item1, index) => {
					if (item.id == item1) {
						this.groupIdList.splice(index, 1);
					}
				});
			});
			if (this.inputlist.cjzm != '') {
				for (let a = 0; a < this.groupIdList.length; a++) {
					this.listset.one.push(this.groupIdList[a]);
				}
				let params = {
					userIdArr: this.listset.one,
					groupName: this.inputlist.cjzm
				};
				if (this.inputlist.groupId != '') {
					params.groupId = this.inputlist.groupId;
				}
				userGroupsave(params).then(res => {
					if (res.data.code == 1) {
						this.Createtzdiag = false;
						this.$message.success('新增成功');
						this.paginationtzz.pageNum = 1;
						this.inputlist.cjzm = '';
						this.group();
					} else {
						this.$message.error(res.data.msg);
					}
				});
			} else {
				this.$message.error('组名称不能为空');
			}
		},
		tzdx() {
			this.paginationtzz.pageNum = '1';
			this.listset.one = [];
			// this.inputlist.cjzm = ''
			this.user();
		},
		savegroup() {
			this.inputlist.groupId = '';
			this.inputlist.cjzm = '';
			this.Createtzdiag = true;
			this.groupIdList = [];
			this.$nextTick(() => {
				this.$refs.grouplist.toggleSelection([]);
			});
			this.user();
		},
		user() {
			let params = {
				size: this.paginationtzz.pageSize,
				current: this.paginationtzz.pageNum,
				username: this.search
			};
			userpage(params).then(res => {
				if (res.data.code == 1) {
					this.tableDataCreate = res.data.data.records;
					this.paginationtzz.total = parseFloat(res.data.data.total);
					let list = [];
					this.tableDataCreate.map(item => {
						this.groupIdList.map(item1 => {
							if (item.id == item1) {
								list.push(item);
							}
						});
					});

					this.$nextTick(() => {
						this.$refs.grouplist.toggleSelection(list);
					});
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		zdzb() {
			let params = {
				size: this.paginationtzz.pageSize,
				current: this.paginationtzz.pageNum,
				suosq: this.suosq,
				companyCode: this.glzb_nsrmc
			};
			noticeindexpage(params).then(res => {
				if (res.data.code == 1) {
					this.zbdiag = true;
					this.paginationtzz.total = parseFloat(res.data.data.total);
					this.tableDatazb = res.data.data.records;
					let list = [];
					this.ouglist.map(item => {
						let num = 0;
						this.tableDatazb.map((item1, index1) => {
							if (item.id == item1.id) {
								list.push(item1);
								num = 1;
							}
						});
					});
					this.$nextTick(() => {
						this.$refs.zbtable.toggleSelection(list);
					});
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		uptz() {
			Object.keys(this.inputlist).map(key => {
				if (key != 'tzpl') {
					this.inputlist[key] = '';
				}
			});
			this.ouglist = [],
			this.inputlist.tzmc = '';
			this.inputlist.isshow = false;
			this.glData = [];
			this.value = null;
			this.radio = null;
			this.title = '新建通知';
			this.tableDataright = [];
			this.search = [];
			this.group();
		},
		group() {
			let params = {
				size: 10000000,
				current: this.paginationtzz.pageNum,
				groupName: this.search
			};
			grouppage(params).then(res => {
				if (res.data.code == 1) {
					this.dialogVisible = true;
					this.tableDataleft = res.data.data.records;
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		updatalist(e) {
			let params = {
				size: this.pagination.pageSize,
				current: this.pagination.pageNum,
				...(e || {})
			};
			indexExpage(params).then(res => {
				if (res.data.code == 1) {
					this.tableData = res.data.data.records;
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		currentChangetz(e) {
			this.paginationtzz.pageNum = e;
			if (this.Createtzdiag == true) {
				let list = this.$refs.grouplist.getSelectionval();
				let deleteList = [];
				this.tableDataCreate.map(item => {
					let num = 0;
					if (list.length == 0) {
						deleteList.push(item);
					} else {
						list.map((item1, index) => {
							if (item.id == item1.id) {
								num++;
							} else if (item.id != item1.id && index == list.length - 1 && num == 0) {
								deleteList.push(item);
							}
						});
					}
				});
				list.map((item1, index) => {
					this.groupIdList.push(Number(item1.id));
				});
				let a = Array.from(new Set(this.groupIdList));
				this.groupIdList = a;
				deleteList.map(item => {
					this.groupIdList.map((item1, index) => {
						if (item.id == item1) {
							this.groupIdList.splice(index, 1);
						}
					});
				});
				this.user();
			} else if (this.zbdiag) {
				this.select_out()
			}
		},
		sizechangetz(e) {
			this.paginationtzz.pageSize = e;
			if (this.Createtzdiag) {
				this.tzdx();
			} else if (this.zbdiag) {
				this.zdzb();
			}
		},
		edit(e) {
			this.paginationtzz.pageNum = 1;
			this.paginationtzz.paginationkey++;
			if (this.Createtzdiag == true) {
				this.search = this.inputlist.tzss;
				if (!e) {
					let groupId = this.inputlist.groupId;
					fetchGroupUser({ groupId: this.inputlist.groupId }).then(res => {
						if (res.data.code == 1) {
							let a = Array.from(new Set(res.data.data));
							this.groupIdList = a;
							this.tzdx();
						} else {
							this.$message.error(res.data.msg);
						}
					});
				} else {
					this.tzdx();
				}
			} else if (this.tzdiag == true) {
				this.search = this.inputlist.mbss;
				this.mbpage();
			} else if (this.dialogVisible) {
				this.search = this.inputlist.input;
				this.group();
			} else {
				this.uptz();
			}
		},
		currentChange(e) {
			this.pagination.pageNum = e;
		},
		sizechange(e) {
			this.pagination.pageSize = e;
		},
		closediagywdiag() {
			this.ywdiag = false;
		},
		submitSearch() {
			this.pagination.pageNum = 1;
			this.pagination.paginationkey++;
			this.updatalist(this.searchdata);
		},
		forUpdateSearch() {
			this.searchdiag = true;
		},
		closeSearch() {
			this.searchdiag = false;
		},
		saveChange(e) {
			this.searchdiag = false;
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
